<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">会议主题：</span>
        <el-input v-model="meetTopic" :size="size" clearable placeholder="请输入会议主题"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">上传时间：</span>
        <el-date-picker
          v-model="meetingTime"
          :size="size"
          clearable
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <div class="header_item">
        <el-button 
          icon="el-icon-search"
          v-if="showButton('search')"
          @click="searchMeetingInfoList(true)"
          >查询</el-button>
        <el-button 
          class="search_btn"
          icon="el-icon-plus" 
          v-if="showButton('insert')"
          @click="propInsert()"
          >新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="meetingList"
        height="100%">
        <el-table-column label="序号" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="meetTopic" label="会议主题" align="center"></el-table-column>
        <el-table-column prop="meetFileName" label="会议文件名称" align="center"></el-table-column>
        <el-table-column prop="createUserName" label="上传人" align="center"></el-table-column>
        <el-table-column prop="meetPersons" label="参会人" align="center"></el-table-column>
        <el-table-column label="上传附件" align="center">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" @click="propLookFile(row)">查看文件</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="上传时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="propUpdate(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增会议文件  修改会议文件信息 -->
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增会议文件' : '修改会议文件信息'"
      :visible.sync="asyncMetting"
      width="35%">
      <el-form ref="form" :model="formMetting" :rules="rulesMetting" label-width="auto" class="rule_form">
        <el-form-item label="会议主题：" prop="meetTopic">
          <el-input v-model="formMetting.meetTopic" :size="size" clearable placeholder="请输入会议主题"></el-input>
        </el-form-item>
        <el-form-item label="会议报告名称：" prop="meetFileName">
          <el-input v-model="formMetting.meetFileName" :size="size" clearable placeholder="请输入会议报告名称"></el-input>
        </el-form-item>
        <el-form-item label="参会人：" prop="meetPersons">
          <el-input 
            type="textarea"
            v-model="formMetting.meetPersons" 
            :size="size" 
            clearable 
            placeholder="请输入参会人"
            ></el-input>
        </el-form-item>
        <el-form-item label="上传附件：" prop="meetfileList">
          <upload-file :file-list.sync="formMetting.meetfileList">
						<template #info>
							<span>点击上传文件，支持xls、xlsx、ppt、doc、docx、pdf格式</span>
						</template>
          </upload-file>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncMetting = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsertForm() : submitUpdateForm()">提 交</el-button>
      </div>
    </el-dialog>
    <!-- 查看文件 -->
    <look-file :file-list.sync="fileList" :async-file.sync="asyncFile"></look-file>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia';
import { changeSize, throttle } from '../../plugins/public';
import UploadFile from '../../components/uploadFile';
import LookFile from '../../components/LookFile';
  export default {
    data() {
      var fileMustUpload = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请上传项目文件'));
        } else if (value.length < 0) {
          callback(new Error('请上传项目文件'));
        } else {
          this.$refs.form.clearValidate('proInfoFiles');
          callback();
        }
      };
      return {
        meetTopic: '',
        meetingTime: '',
        size: changeSize(),
        total: 0,
        pageNum: 1,
        pageSize: 10,
        loading: false,
        meetingList: [], // 列表信息
        asyncTitle: true, // true 新增会议  false 修改会议信息
        asyncMetting: false, // 弹窗
        formMetting: {
          meetfileList: []
        }, // 表单信息
        rulesMetting: {
          meetTopic: [{
            required: true,
            message: '请输入会议主题',
            trigger: 'blur'
          }],
          meetFileName: [{
            required: true,
            message: '请输入会议文件名称',
            trigger: 'blur'
          }],
          meetPersons: [{
            required: true,
            message: '请输入参会人',
            trigger: 'blur'
          }],
          meetfileList: [{
            required: true,
            message: '请上传文件'
          }, {
            validator: fileMustUpload,
            trigger: ['change']
          }]
        }, // 表单校验信息
        fileList: [],
        asyncFile: false
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchMeetingInfoList(true);
    },
    methods: {
      // 查询会议文件信息
      async searchMeetingFileList(meetFileId) {
        const { data } = await this.$api.Project.searchMeetingFileList({
          meetFileId: meetFileId
        });
        return data;
      },
      // 查询会议信息列表
      searchMeetingInfoList(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        this.loading = true;
        this.meetingList = [];
        this.$api.Project.searchMeetingInfoList({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          meetTopic: this.meetTopic,
          startTime: this.meetingTime ? this.meetingTime[0] + ' 00:00:00' : '',
          endTime: this.meetingTime ? this.meetingTime[1] + ' 23:59:59' : ''
        }).then((res) => {
          if(res.success) {
            this.total = res.data.total;
            this.meetingList = res.data.list;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      // 打开添加信息
      propInsert() {
        this.aysncTitle = true;
        this.asyncMetting = true;
      },
      // 打开修改信息
      propUpdate(row) {
        this.aysncTitle = false;
        this.asyncMetting = true;
        this.$set(this.formMetting, 'meetFileId', row.meetFileId);
        this.$set(this.formMetting, 'meetTopic', row.meetTopic);
        this.$set(this.formMetting, 'meetFileName', row.meetFileName);
        this.$set(this.formMetting, 'meetPersons', row.meetPersons);
        this.searchMeetingFileList(row.meetFileId).then((data) => {
          this.$set(this.formMetting, 'meetfileList', data.list.map(item => {
            const type = item.meetFile.split('.');
            return {
              id: item.id,
              type: type[type.length - 1],
              name: item.meetFileName,
              url: item.meetFile
            }
          }));
        })
      },
      // 查看文件
      propLookFile(row) {
        this.fileList = [];
        this.searchMeetingFileList(row.meetFileId).then((data) => {
         const list = data.list.map(item => {
            const type = item.meetFile ? item.meetFile.split('.') : '';
            return {
              id: item.id,
              type: type[type.length - 1],
              name: item.meetFileName,
              url: item.meetFile
            }
          })
          this.fileList = list;
        });
        this.asyncFile = true;
      },
      // 删除信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该会议信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Project.deleteMeetingInfo({meetFileId: row.meetFileId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchMeetingInfoList(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加信息
      submitInsertForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formMetting);
            params.meetfileList = params.meetfileList.map(item => {
              return {
                meetFile: item.url
              }
            });
            this.$api.Project.insertMeetingInfo(params).then((res) => {
              if(res.success) {
                this.asyncMetting = false;
                this.searchMeetingInfoList(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改信息
      submitUpdateForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formMetting);
            params.meetfileList = params.meetfileList.map(item => {
              return {
                meetFile: item.url
              }
            });
            this.$api.Project.insertMeetingInfo(params).then((res) => {
              if(res.success) {
                this.asyncMetting = false;
                this.searchMeetingInfoList(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 切换页码
      changePageNum(page) {
        this.pageNum = page;
        this.searchMeetingInfoList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchMeetingInfoList();
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      }
    },
    components: {
      UploadFile,
      LookFile
    },
    watch: {
      asyncMetting(bol) {
        if(!bol) {
          this.formMetting = {
            meetfileList: []
          };
          this.$refs.form.resetFields();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';
</style>